import usaFlag from "../assets/images/usa-flag.svg";
import prophylacticVaccinesIcon from "../assets/images/prophylactic-vaccines-icon.png";
import authorizedDealer from "../assets/images/authorized-dealer.svg";
import reservations from "../assets/images/reservations.svg";
import upwardChart from "../assets/images/upward-chart.png";
import successBadge from "../assets/images/success-badge.svg";
import shipping from "../assets/images/shipping.svg";
import delivery from "../assets/images/delivery.svg";
import temperatureMonitoring from "../assets/images/temperature-monitoring.svg";
import troubleshooting from "../assets/images/troubleshooting.svg";
import accessMedicine from "../assets/images/access-medicine.png";
import websiteTroubleshooting from "../assets/images/website-troubleshooting.svg";
import accounts from "../assets/images/accounts.png";

export const faqCategoriesData = [
    {
    fields: {
        title: 'Account - US',
        name: 'Account',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1oWjvwUekvAkypRl9mYDU2',
            type: 'Entry',
            createdAt: '2024-03-04T19:49:19.988Z',
            updatedAt: '2024-03-04T19:49:19.988Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I create a new account on ModernaDirect.com? - US',
            question: 'How do I create a new account on ModernaDirect.com? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Select “Create a new account” during log in and provide either a HIN or DEA number to find your account. If you experience any issues, please contact your Account Manager or contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7iC7HZ1qh8w2F0i8zoI9rO',
            type: 'Entry',
            createdAt: '2022-10-26T22:35:57.633Z',
            updatedAt: '2024-03-04T19:49:46.484Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 32,
            revision: 8,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Am I affiliated with a Group Purchasing Organization (GPO) or other contract entity?  - US',
            question: 'Am I affiliated with a Group Purchasing Organization (GPO) or other contract entity? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Please click “My Account” to view your account details, which will show any contract affiliation(s). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5k6A7RdsqLLrrJQilZaPiN',
            type: 'Entry',
            createdAt: '2023-01-09T19:46:37.151Z',
            updatedAt: '2024-03-04T19:50:08.369Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 24,
            revision: 6,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'My contract affiliation is not correct. How can I fix it? - US',
            question: 'My contract affiliation is not correct. How can I fix it? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Please contact your Account Manager or contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) to verify your contract affiliation or contact customer service. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '2Hqe0Ghpiu1DLaWsIC3gNF',
            type: 'Entry',
            createdAt: '2023-01-09T19:47:35.354Z',
            updatedAt: '2024-03-04T19:50:32.535Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 19,
            revision: 7,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why can’t I change / update my account information?',
            question: 'Why can’t I change / update my account information? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Fields that can be edited will have an “edit” button next to them. However, some fields may be temporarily locked. To update or change information at the account level, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '16L3tb5eMUdaaSKWnT0R2A',
            type: 'Entry',
            createdAt: '2023-01-09T19:49:26.296Z',
            updatedAt: '2024-03-04T19:50:54.740Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 36,
            revision: 11,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I reset my password? - US',
            question: 'How do I reset my password?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'To change or reset your password, you’ll need to first log out of ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'ModernaDirect.com',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: '. Then, go to the Homepage, click on “Forgot Password,” and follow the prompts. If you have trouble with any part of the process, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7cvVETbdfmc4G1Fj7XJZbK',
            type: 'Asset',
            createdAt: '2023-01-20T13:16:58.825Z',
            updatedAt: '2023-01-20T13:23:17.055Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 7,
            revision: 2,
            locale: 'en-US'
        },
        fields: {
            title: 'Icon US Employee benefits',
            description: 'Icon US Employee benefits',
            file: {
            url: accounts,
            details: {
                size: 13512,
                image: {
                width: 501,
                height: 501
                }
            },
            fileName: 'Moderna_Icon_USEmployeeBenefits.png',
            contentType: 'image/png'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7sht7920U6vs3CLH2CUyaa',
            type: 'Entry',
            createdAt: '2023-05-18T03:23:50.744Z',
            updatedAt: '2023-05-24T22:55:23.250Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '6RquDCvRRFNOFyGlq58b4a',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Ordering from Moderna - US',
        name: 'Ordering from Moderna ',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '2hwboHkQnRMNGwcQHrb90r',
            type: 'Entry',
            createdAt: '2023-09-11T19:58:49.226Z',
            updatedAt: '2024-03-04T19:31:57.151Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 12,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What products are available to order?  - US',
            question: 'What products are available to order? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Ordering is available for the updated 2023-2024 formulations of the COVID-19 Vaccine: ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'unordered-list',
                    data: {},
                    content: [
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Spikevax (COVID-19 vaccine, mRNA) 2023-2024 Formula ',
                                marks: [],
                                data: {}
                            }
                            ]
                        },
                        {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                            {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                    {
                                        nodeType: 'text',
                                        value: '0.5 mL Prefilled Syringe - For ages 12 years and older ',
                                        marks: [],
                                        data: {}
                                    }
                                    ]
                                }
                                ]
                            },
                            {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                    {
                                        nodeType: 'text',
                                        value: '0.5 mL Single Dose Vial - For ages 12 years and older ',
                                        marks: [],
                                        data: {}
                                    }
                                    ]
                                }
                                ]
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Moderna COVID-19 Vaccine (2023-2024 Formula):  ',
                                marks: [],
                                data: {}
                            }
                            ]
                        },
                        {
                            nodeType: 'unordered-list',
                            data: {},
                            content: [
                            {
                                nodeType: 'list-item',
                                data: {},
                                content: [
                                {
                                    nodeType: 'paragraph',
                                    data: {},
                                    content: [
                                    {
                                        nodeType: 'text',
                                        value: '0.25 mL Single Dose Vial - For ages 6 months through 11 years ',
                                        marks: [],
                                        data: {}
                                    }
                                    ]
                                }
                                ]
                            }
                            ]
                        }
                        ]
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: '',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1TJN6GVo2jJvOY5WeRwlwx',
            type: 'Entry',
            createdAt: '2024-03-04T19:33:21.605Z',
            updatedAt: '2024-03-04T19:33:21.605Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What products are available to reserve? - US',
            question: 'What products are available to reserve? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Customers known to Moderna (for example, those who placed an order via ModernaDirect.com in 2023) will be able to reserve the following products starting on March 5, 2024',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [
                        {
                            type: 'bold'
                        }
                        ],
                        value: '.',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [],
                        value: '  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'Spikevax (COVID-19 vaccine, mRNA) 2024-2025 Formula  ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        },
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                content: [
                                {
                                    data: {},
                                    content: [
                                    {
                                        data: {},
                                        marks: [],
                                        value: '0.5 mL Pre-filled Syringe - For ages 12 years and older  ',
                                        nodeType: 'text'
                                    }
                                    ],
                                    nodeType: 'paragraph'
                                }
                                ],
                                nodeType: 'list-item'
                            },
                            {
                                data: {},
                                content: [
                                {
                                    data: {},
                                    content: [
                                    {
                                        data: {},
                                        marks: [],
                                        value: '0.5 mL Single Dose Vial - For ages 12 years and older  ',
                                        nodeType: 'text'
                                    }
                                    ],
                                    nodeType: 'paragraph'
                                }
                                ],
                                nodeType: 'list-item'
                            }
                            ],
                            nodeType: 'unordered-list'
                        }
                        ],
                        nodeType: 'list-item'
                    },
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'Moderna COVID-19 Vaccine (2024-2025 Formula) ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        },
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                content: [
                                {
                                    data: {},
                                    content: [
                                    {
                                        data: {},
                                        marks: [],
                                        value: '0.25 mL Pre-filled Syringe - For ages 6 months through 11 years ',
                                        nodeType: 'text'
                                    }
                                    ],
                                    nodeType: 'paragraph'
                                }
                                ],
                                nodeType: 'list-item'
                            }
                            ],
                            nodeType: 'unordered-list'
                        }
                        ],
                        nodeType: 'list-item'
                    }
                    ],
                    nodeType: 'unordered-list'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: '',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1NRamRyoFbwSGdl1wS5UTE',
            type: 'Entry',
            createdAt: '2023-09-11T19:59:17.626Z',
            updatedAt: '2024-03-04T19:34:08.097Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 7,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What are the 2023-2024 and 2024-2025 CPT codes?  - US',
            question: 'What are the 2023-2024 and 2024-2025 CPT codes? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'To access CPT codes online, visit our ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://reimbursement.modernatx.com/'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'Billing Codes',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ' portal. If you need to speak with a representative for further information, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).    ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '27TJybbgkqi4gX95AZDEPg',
            type: 'Entry',
            createdAt: '2022-10-26T22:33:19.098Z',
            updatedAt: '2024-03-04T19:35:09.811Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 42,
            revision: 12,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'When will my order ship? - US',
            question: 'When will my order ship?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you made your reservation and confirmed your order prior to June 1, 2024, your products will ship as soon as they are available. Orders placed after June 1 will be fulfilled in the order in which they are received.  ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1RYVhxM0ihpnG0h4EWWBN2',
            type: 'Entry',
            createdAt: '2022-10-26T22:37:24.834Z',
            updatedAt: '2024-03-04T19:35:37.294Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 32,
            revision: 11,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What should I do if I have issues with my order? - US',
            question: 'What should I do if I have issues with my order? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7k1yKeNCJU3DfwejqfL0To',
            type: 'Entry',
            createdAt: '2023-01-09T20:23:20.405Z',
            updatedAt: '2024-03-04T19:36:04.796Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 33,
            revision: 9,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the minimum number of vials/doses I can order? - US',
            question: 'What is the minimum number of vials/doses I can order? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'You can order a minimum of 10 vials. Each vial contains one (1) vaccine dose, and there are 10 vials/doses in one (1) carton. Moderna vaccines are sold by the carton, and it is not possible to order partial cartons. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6aCUd0orBA6K4v9ayc94m3',
            type: 'Entry',
            createdAt: '2023-01-09T20:31:05.354Z',
            updatedAt: '2024-03-04T19:36:29.869Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 42,
            revision: 12,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the minimum number of prefilled syringes I can order?  - US',
            question: 'What is the minimum number of prefilled syringes I can order? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'You can order a minimum of 10 syringes. Each syringe contains one (1) vaccine dose, and there are 10 syringes/doses in one (1) carton. Moderna vaccines are sold by the carton, and it is not possible to order partial cartons. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'sHqA6QdHLHH8G1qr8RteQ',
            type: 'Entry',
            createdAt: '2023-08-14T18:01:21.366Z',
            updatedAt: '2024-03-04T19:37:05.194Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 7,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the maximum number of vials/doses I can order? - US',
            question: 'What is the maximum number of vials/doses I can order?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Currently, there is no limit on the number of vials ordered, though they must be ordered in multiples of 10 (or 1 full carton).   ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1L0v8OsUb1zWsz4KRqr6Tb',
            type: 'Entry',
            createdAt: '2023-08-14T18:01:58.330Z',
            updatedAt: '2024-03-04T19:37:25.578Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the maximum number of pre-filled syringes I can order?  - US',
            question: 'What is the maximum number of pre-filled syringes I can order? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Currently, there is no limit on the number of syringes ordered. However, for orders of 1,000 or more, please contact your Moderna account representative. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3baYTU4j1lFQBxSVGiH5iW',
            type: 'Entry',
            createdAt: '2023-01-09T20:32:03.008Z',
            updatedAt: '2024-03-04T19:37:46.220Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 18,
            revision: 7,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Are multi-dose vials available?  - US',
            question: 'Are multi-dose vials available? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'No, multi-dose vials are not available. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7Ko3abvR1paZCtUVmwcFph',
            type: 'Entry',
            createdAt: '2023-01-09T20:45:44.944Z',
            updatedAt: '2024-03-04T19:43:38.727Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 21,
            revision: 7,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I order through my distributor? - US',
            question: 'Can I order through my distributor? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Yes. Check out our list of ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'Authorized Distributors.',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ' If you can’t find your preferred distributor, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1jcr7aX4GRnPo9oediRcSv',
            type: 'Entry',
            createdAt: '2023-01-09T21:49:31.119Z',
            updatedAt: '2024-03-04T19:44:33.937Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 24,
            revision: 8,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Are there any quantity discounts? - US',
            question: 'Are there any quantity discounts?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'There are no additional discounts available beyond your contract affiliation. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7xWZHr2PjK5mJ9tYkLlAzU',
            type: 'Entry',
            createdAt: '2024-03-04T19:45:27.608Z',
            updatedAt: '2024-03-04T19:45:27.608Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'My business is tax-exempt. How can I get this recorded on my account? - US',
            question: 'My business is tax-exempt. How can I get this recorded on my account? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Our ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://taxform.modernatx.com/'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'Tax Exemption Form Tool',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ' is designed to help our valued customers submit their tax exemption certificates. To simplify and expedite this process, the page contains instructions to guide you through a secure process of uploading your tax exemption certificates. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4Vu88k5X1DDkdoJ2QuPmHB',
            type: 'Entry',
            createdAt: '2023-01-09T22:05:49.208Z',
            updatedAt: '2024-03-04T19:46:21.645Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 28,
            revision: 10,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What does the order status “pending” mean? - US',
            question: 'What does the order status “pending” mean? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Order status "pending" indicates that ModernaDirect.com has sent your order to the 3PL partner to process, but it hasn\'t been processed and shipped yet. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4kcQbabycuXDBFu6Yz9NyU',
            type: 'Entry',
            createdAt: '2023-08-14T18:03:01.033Z',
            updatedAt: '2024-03-04T19:46:42.462Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 7,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the latest time that an order can be placed for next-day delivery?  - US',
            question: 'What is the latest time that an order can be placed for next-day delivery? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Orders placed before 10am ET can be scheduled for next-day delivery.   ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3alIUt5P12EWcscT96a7rO',
            type: 'Entry',
            createdAt: '2023-08-14T18:03:47.665Z',
            updatedAt: '2024-03-04T19:47:05.009Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 11,
            revision: 3,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I receive an order on a Saturday or Sunday? - US',
            question: 'Can I receive an order on a Saturday or Sunday? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'We do offer weekend shipping options. However, we ask that you contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) to schedule a weekend delivery.   ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '21Va5b3RHBHq3Rirq7z0JO',
            type: 'Asset',
            createdAt: '2022-12-29T16:19:31.860Z',
            updatedAt: '2023-07-26T13:10:18.659Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 10,
            revision: 2,
            locale: 'en-US'
        },
        fields: {
            title: 'Icon Prophylactic Vaccines',
            description: 'Icon Prophylactic Vaccines',
            file: {
            url: prophylacticVaccinesIcon,
            details: {
                size: 40893,
                image: {
                width: 600,
                height: 600
                }
            },
            fileName: 'Icon_ProphylacticVaccines.png',
            contentType: 'image/png'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7sht7920U6vs3CLH2CUyaa',
            type: 'Entry',
            createdAt: '2023-05-18T03:23:50.744Z',
            updatedAt: '2023-05-24T22:55:23.250Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '25xsJYEr8axEnFWQiyVwvw',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Ordering via Authorized Distributor - US',
        name: 'Ordering via Authorized Distributor ',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3XvWeWWLVn5a0fxzTCfhis',
            type: 'Entry',
            createdAt: '2024-03-04T19:53:35.371Z',
            updatedAt: '2024-03-04T19:53:35.371Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I order Moderna vaccines through my distributor? - US',
            question: 'Can I order Moderna vaccines through my distributor? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Moderna works with several ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'Authorized Distributors',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ' to ensure a smooth customer experience. Customers who order through these distributors are considered “indirect customers.”   ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4ovuY6QwtRsr76Ja1PTANT',
            type: 'Entry',
            createdAt: '2024-03-04T19:54:22.685Z',
            updatedAt: '2024-03-04T19:54:22.685Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What are the benefits of choosing an Authorized Distributor participating in the P.E.R.K. program?  - US',
            question: 'What are the benefits of choosing an Authorized Distributor participating in the P.E.R.K. program?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'The P.E.R.K. program highlights ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'Authorized Distributors',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ' that share our commitment to delivering an exceptional experience.   ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [
                        {
                            type: 'bold'
                        }
                        ],
                        value: 'P',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [],
                        value: 'referred: They are chosen for their superior service.  \n',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [
                        {
                            type: 'bold'
                        }
                        ],
                        value: 'E',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [],
                        value: 'fficient: They streamline processes for faster customer onboarding.  \n',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [
                        {
                            type: 'bold'
                        }
                        ],
                        value: 'R',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [],
                        value: 'apid: They provide faster shipping options.  \n',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [
                        {
                            type: 'bold'
                        }
                        ],
                        value: 'K',
                        nodeType: 'text'
                    },
                    {
                        data: {},
                        marks: [],
                        value: 'nowledgeable: They offer overall better service due to their expertise.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Customers ordering via P.E.R.K. distributors will benefit from: ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'An optimized web experience for making advance reservations and regular season orders.  ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        }
                        ],
                        nodeType: 'list-item'
                    },
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'Faster account creation: New business accounts can be created, verified, and approved for ordering in 2 business days. ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        }
                        ],
                        nodeType: 'list-item'
                    },
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'A dedicated customer contact for all inquiries (via phone or email, depending on the distributor).  ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        }
                        ],
                        nodeType: 'list-item'
                    },
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: '2-day shipment for all available products.  ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        }
                        ],
                        nodeType: 'list-item'
                    },
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'The option of paying via credit card.  ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        }
                        ],
                        nodeType: 'list-item'
                    }
                    ],
                    nodeType: 'unordered-list'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: '',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '2j1HsjRISqj1CkWwtrbzuV',
            type: 'Entry',
            createdAt: '2024-03-04T19:58:09.434Z',
            updatedAt: '2024-03-04T19:58:09.434Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How can I identify distributors that participate in the Moderna P.E.R.K program? - US',
            question: 'How can I identify distributors that participate in the Moderna P.E.R.K program? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'These distributors will be highlighted on the ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'Authorized Distributors',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ' page. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3qO7NySzQA47sv2A2gWRKV',
            type: 'Entry',
            createdAt: '2024-03-04T19:59:20.224Z',
            updatedAt: '2024-03-04T19:59:20.224Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'I am an indirect customer (I ordered through a distributor and not directly from Moderna). Whom should I contact for my order queries?\u202f - US',
            question: 'I am an indirect customer (I ordered through a distributor and not directly from Moderna). Whom should I contact for my order queries?\u202f ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'You can contact the ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'Authorized Distributor',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ' you purchased from and they will be able to help you. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3NQgMI6F05sUo2jRGFb0l4',
            type: 'Entry',
            createdAt: '2024-03-04T19:59:53.226Z',
            updatedAt: '2024-03-04T19:59:53.226Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can an Authorized Distributor validate the ship date and speak about the shipping containers and gel packs?\u202f - US',
            question: 'Can an Authorized Distributor validate the ship date and speak about the shipping containers and gel packs?\u202f ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Yes, the ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'Authorized Distributor',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ' will validate the ship date and provide information about the shipping containers, gel packs, and the expected condition of the product upon delivery.\u202f ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3uPn4IhrcmykaFrhbi8UDu',
            type: 'Entry',
            createdAt: '2024-03-04T20:00:33.205Z',
            updatedAt: '2024-03-04T21:14:45.341Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 7,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Where do I return my shipment if I’m an indirect customer?\u202f\u202f - US',
            question: 'Where do I return my shipment if I’m an indirect customer?\u202f',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you need to return the product, please confirm the return process with your ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'Authorized Distributor',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: '. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '4jffF0O6AIwxvkRccnjPZg',
            type: 'Asset',
            createdAt: '2024-03-04T19:52:38.274Z',
            updatedAt: '2024-03-04T19:52:38.274Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 5,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Ordering via Authorized Distributor Icon',
            description: 'Ordering via Authorized Distributor Icon',
            file: {
            url: authorizedDealer,
            details: {
                size: 2043,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '1.authorizedDealer.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7iOWBmppZrkK5s40UUIzOV',
            type: 'Entry',
            createdAt: '2023-09-28T22:24:03.948Z',
            updatedAt: '2023-09-28T22:24:03.948Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '1L20KgO05pIWHr5ZCxr214',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Reservations - US',
        name: 'Reservations ',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1rBDO0t1LzKI4FiYKSyqzy',
            type: 'Entry',
            createdAt: '2024-03-04T20:01:57.175Z',
            updatedAt: '2024-03-04T20:01:57.175Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is a reservation? - US',
            question: 'What is a reservation? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'A reservation is not an active order—it tells Moderna how much vaccine supply you anticipate needing for your patient population. Reservations allow Moderna to manufacture appropriate quantities of vaccines.  ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '30LHtXynOnG1giAaQUUYtj',
            type: 'Entry',
            createdAt: '2024-03-04T20:02:28.065Z',
            updatedAt: '2024-03-04T20:02:28.065Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Is my reservation a commitment to purchase the vaccine? - US',
            question: 'Is my reservation a commitment to purchase the vaccine? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'No. Any reservation you made will not become a commitment to purchase the vaccine until you convert it to an order.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '29Q1L3ztybXOfCTQnNTpfS',
            type: 'Entry',
            createdAt: '2024-03-04T20:02:54.519Z',
            updatedAt: '2024-03-04T20:02:54.519Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'When does the reservation window open for 2024-2025 COVID-19 vaccines? - US',
            question: 'When does the reservation window open for 2024-2025 COVID-19 vaccines?',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Customers who are currently registered with Moderna and have placed direct orders with us in the past will begin receiving invitations to make reservations beginning in early March 2024. As we continue to expand access to the reservation process over the following weeks, other customers will receive an email alerting them to the day when their registration window begins.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4ZH6hUHPTHBZFzHbE5ZQ57',
            type: 'Entry',
            createdAt: '2024-03-04T20:04:15.566Z',
            updatedAt: '2024-03-04T20:04:15.566Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the last day I can reserve my vaccine supply on ModernaDirect.com?  - US',
            question: 'What is the last day I can reserve my vaccine supply on ModernaDirect.com?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'The last day to place a reservation for priority delivery is June 1, 2024. After this date, orders will be filled based on the order in which they are received.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4pegl2d71b9r0WsHMiGLuv',
            type: 'Entry',
            createdAt: '2024-03-04T20:04:57.655Z',
            updatedAt: '2024-03-04T20:04:57.655Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why should I reserve my vaccine supply in advance instead of waiting until the vaccines are available for shipping?  - US',
            question: 'Why should I reserve my vaccine supply in advance instead of waiting until the vaccines are available for shipping?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Reserving your vaccine supply in advance grants you access to priority shipping. This means your order confirmed orders will be shipped as soon as the product is available if you made your reservation before June 1, 2024.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3UdUpnf1GJ63QJO7wvCVth',
            type: 'Entry',
            createdAt: '2024-03-04T20:05:41.353Z',
            updatedAt: '2024-03-04T20:05:41.353Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'I made a reservation, but I haven’t heard about my order shipment date. What should I do?  - US',
            question: 'I made a reservation, but I haven’t heard about my order shipment date. What should I do?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'After you make your reservation, we will send an email when pricing is available and ask you to confirm your order. Unconfirmed orders cannot be shipped.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'If you confirmed your order and have questions about your shipping date that were not answered in Moderna’s email communications to you, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4GihPRBETGXPARRqPiFKuZ',
            type: 'Entry',
            createdAt: '2024-03-04T20:06:34.977Z',
            updatedAt: '2024-03-04T20:06:34.977Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I edit or cancel my reservation?  - US',
            question: 'Can I edit or cancel my reservation?  ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Yes, we have enhanced our website to allow customers to edit or cancel their reservations online. Starting in late March 2024, you may edit or cancel your vaccine reservation or update your order details up to one week before it ships. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4BCjwfGD7FiaAg1dM59PEp',
            type: 'Entry',
            createdAt: '2024-03-04T20:07:12.179Z',
            updatedAt: '2024-03-04T20:07:12.179Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I edit my vaccine reservation?  - US',
            question: 'How do I edit my vaccine reservation?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'In order to give you more control over your reservations, we have enabled a feature to allow direct ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://modernadirect.com/'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'ModernaDirect.com',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ' customers to edit their vaccine reservations directly through the website.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'To edit your reservation: ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'Navigate to your ',
                                nodeType: 'text'
                            },
                            {
                                data: {
                                uri: 'https://modernadirect.com/orders'
                                },
                                content: [
                                {
                                    data: {},
                                    marks: [
                                    {
                                        type: 'underline'
                                    }
                                    ],
                                    value: 'order history',
                                    nodeType: 'text'
                                }
                                ],
                                nodeType: 'hyperlink'
                            },
                            {
                                data: {},
                                marks: [],
                                value: '. ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        }
                        ],
                        nodeType: 'list-item'
                    },
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'Select the reservation you wish to modify. ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        }
                        ],
                        nodeType: 'list-item'
                    },
                    {
                        data: {},
                        content: [
                        {
                            data: {},
                            content: [
                            {
                                data: {},
                                marks: [],
                                value: 'Input your new reservation details.  ',
                                nodeType: 'text'
                            }
                            ],
                            nodeType: 'paragraph'
                        }
                        ],
                        nodeType: 'list-item'
                    }
                    ],
                    nodeType: 'ordered-list'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: '',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5sbSoRRzc28DhEAgr5yzG4',
            type: 'Entry',
            createdAt: '2024-03-04T20:08:02.831Z',
            updatedAt: '2024-03-04T20:08:02.831Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'I made a reservation, but I need to order more vaccines. Why can\'t I order more than my reservation allocation? - US',
            question: 'I made a reservation, but I need to order more vaccines. Why can\'t I order more than my reservation allocation? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you wish to order more vaccines than what\'s listed on your confirmed reservation, a separate sales order is necessary. Please place a separate order for the additional quantity. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: 'HUEjwwBqvw6nVwZ7s7IpM',
            type: 'Asset',
            createdAt: '2024-03-04T20:01:36.006Z',
            updatedAt: '2024-03-04T20:01:36.006Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Reservations Icon',
            description: 'Reservations Icon',
            file: {
            url: reservations,
            details: {
                size: 1888,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '2.reservations.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7iOWBmppZrkK5s40UUIzOV',
            type: 'Entry',
            createdAt: '2023-09-28T22:24:03.948Z',
            updatedAt: '2023-09-28T22:24:03.948Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '3wjHHVMeGQ3e5iXpwmFWoD',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Pricing - US',
        name: 'Pricing',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4RrLr6se2T3LzB5vlr92Og',
            type: 'Entry',
            createdAt: '2023-01-09T21:43:01.903Z',
            updatedAt: '2024-03-04T20:10:26.783Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 30,
            revision: 7,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What does the price include? - US',
            question: 'What does the price include?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'The price shown on the site is the price per carton (which contains either 10 syringes or vials) This is based on either the list price or the price available to you through your contract affiliation. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7aKqU9avzRnpO2qhza0sgC',
            type: 'Entry',
            createdAt: '2023-01-09T21:48:25.728Z',
            updatedAt: '2024-03-04T20:10:41.880Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 23,
            revision: 7,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'I don’t think the prices I’m seeing are correct. - US',
            question: 'I don’t think the prices I’m seeing are correct. ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If your contract affiliation is correct, but the prices still seem wrong, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '2H0dSm1AoalAAVEWNZO1si',
            type: 'Entry',
            createdAt: '2022-10-26T22:29:37.849Z',
            updatedAt: '2024-03-04T20:11:32.334Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 37,
            revision: 8,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How can I see which contract affiliation my account is associated with to ensure I’m receiving the correct price? - US',
            question: 'How can I see which contract affiliation my account is associated with to ensure I’m receiving the correct price? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'You can view your contract affiliation details by clicking “My Account.” If you need more guidance on questions related to contract affiliations and pricing, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1hfJLEW2QBd6WFTppDjAwH',
            type: 'Entry',
            createdAt: '2024-03-04T20:12:02.892Z',
            updatedAt: '2024-03-04T20:12:02.892Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the Merck and Moderna Special Offer (MMSO)? - US',
            question: 'What is the Merck and Moderna Special Offer (MMSO)? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'The MMSO (Merck and Moderna Special Offer) is a collaborative discount program between Moderna and Merck, offering customers an additional 2% discount when they purchase both the VAXNEUVANCE vaccine from Merck and the 2023-2024 Moderna COVID-19 vaccine together. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'PN5rIGT2WHTBQxER0ufgt',
            type: 'Entry',
            createdAt: '2024-03-04T20:12:24.652Z',
            updatedAt: '2024-03-04T20:12:24.652Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I know if I am eligible for the MMSO discount? - US',
            question: 'How do I know if I am eligible for the MMSO discount? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Eligibility for the MMSO discount requires enrollment and independent validation. Once you register your account on Merck’s website at ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://www.mymerckaccounts.com/'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'mymerckaccounts.com',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ', your eligibility will be validated based on your contractual agreements with both Moderna and Merck.  ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4hhEX3j7hS0fVOdupEO4WJ',
            type: 'Entry',
            createdAt: '2024-03-04T20:12:47.220Z',
            updatedAt: '2024-03-04T20:12:47.220Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Is the MMSO discount also applicable on purchases made through distributors? - US',
            question: 'Is the MMSO discount also applicable on purchases made through distributors? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Yes, the MMSO discount is applicable for products purchased directly from Moderna or via our ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'Authorized Distributors',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: '. Customers should ensure they are enrolled and validated in the program to receive the discount. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'hUAIYHpiNYkZaDYma0VZ0',
            type: 'Entry',
            createdAt: '2024-03-04T20:13:12.018Z',
            updatedAt: '2024-03-04T20:13:12.018Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How is the MMSO discount administered? - US',
            question: 'How is the MMSO discount administered? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'This will be an on-invoice discount (OID), meaning it will be directly applied to your purchase invoice once your eligibility is confirmed. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'X5e17dI4XUnxd0yhiwJo1',
            type: 'Entry',
            createdAt: '2024-03-04T20:13:36.405Z',
            updatedAt: '2024-03-04T20:13:36.405Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Does the MMSO discount affect other purchase agreements? - US',
            question: 'Does the MMSO discount affect other purchase agreements? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'No, the MMSO discount is in addition to any discounts you may already have under any other purchase agreements. It does not invalidate or affect the terms of previous purchase agreements. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5mA2jaOzWCcjeBmLVyoZDi',
            type: 'Entry',
            createdAt: '2024-03-04T20:14:00.173Z',
            updatedAt: '2024-03-04T20:14:00.173Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I combine the MMSO discount with other discounts? - US',
            question: 'Can I combine the MMSO discount with other discounts? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Yes, the MMSO discount is designed to be in addition to any other discounts you receive under different purchase agreements. It provides extra savings on top of what you are already receiving. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '6NE0vQiEELQqjbis2VrANh',
            type: 'Asset',
            createdAt: '2023-01-20T13:25:41.119Z',
            updatedAt: '2023-01-20T13:25:41.119Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 7,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Icon Upward chart',
            description: 'Icon Upward chart',
            file: {
            url: upwardChart,
            details: {
                size: 9904,
                image: {
                width: 501,
                height: 500
                }
            },
            fileName: 'Icon Upward chart.png',
            contentType: 'image/png'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7sht7920U6vs3CLH2CUyaa',
            type: 'Entry',
            createdAt: '2023-05-18T03:23:50.744Z',
            updatedAt: '2023-05-24T22:55:23.250Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '5VBlfWFhoyq1vfglC5RZBJ',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Payments - US',
        name: 'Payments ',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5hWQIf9TDk2uIqcJckxOW2',
            type: 'Entry',
            createdAt: '2024-03-04T20:17:09.514Z',
            updatedAt: '2024-03-29T20:41:30.017Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Does Moderna accept credit card payments? - US',
            question: 'Does Moderna accept credit card payments? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'We do not accept credit card payments at this time. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5J6yG4qU3Mh7Xohm2UkAb0',
            type: 'Entry',
            createdAt: '2024-03-04T20:17:26.557Z',
            updatedAt: '2024-03-29T20:41:35.375Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Does Moderna accept ACH payments? - US',
            question: 'Does Moderna accept ACH payments? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'We do not ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'text',
                        value: 'accept ACH payments at this time. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '2J9y4hFXpMFj6OD9HLfddR',
            type: 'Asset',
            createdAt: '2024-03-04T20:16:38.157Z',
            updatedAt: '2024-03-04T20:16:38.157Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Payments Icon',
            description: 'Payments Icon',
            file: {
            url: successBadge,
            details: {
                size: 2775,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '3.Payments.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7iOWBmppZrkK5s40UUIzOV',
            type: 'Entry',
            createdAt: '2023-09-28T22:24:03.948Z',
            updatedAt: '2023-09-28T22:24:03.948Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: 'LJXpAyJ4TU2EJ1zGi4yST',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Shipping - US',
        name: 'Shipping',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5ZU2EhAOzpDXDR0h4h4Jp1',
            type: 'Entry',
            createdAt: '2024-03-04T20:32:03.194Z',
            updatedAt: '2024-03-04T20:32:03.194Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How can I add a new shipping location to my account?  - US',
            question: 'How can I add a new shipping location to my account?  ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you need to add a new address, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6F3LAPnT5Pk3Toswv9u53w',
            type: 'Entry',
            createdAt: '2024-03-04T20:32:23.848Z',
            updatedAt: '2024-03-04T20:32:23.848Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I update my shipping address? - US',
            question: 'How do I update my shipping address? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'In your cart, you can use the drop-down menu to choose an alternate shipping address that you’ve already added to your account. If you need to add a new address, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4R2WfZqGl7wcmGbkgEj1iX',
            type: 'Entry',
            createdAt: '2024-03-04T20:32:43.377Z',
            updatedAt: '2024-03-04T20:32:43.377Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I have my order delivered to more than one address?  - US',
            question: 'Can I have my order delivered to more than one address?  ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Yes. In your cart, choose “Add location” under the current shipping address and select a different address. For each shipping address, select the number of cartons you want delivered to each location.  ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6WVZVvKn3Xiq6AM8p6uCrF',
            type: 'Entry',
            createdAt: '2024-03-04T20:33:02.979Z',
            updatedAt: '2024-03-04T20:33:02.979Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why can’t I see all my associated shipping locations?  - US',
            question: 'Why can’t I see all my associated shipping locations?  ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you entered an address but it does not appear as a delivery location option, that means it could not be validated. Please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).      ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '62HJE2UauGMjim6KnoodMS',
            type: 'Entry',
            createdAt: '2024-03-04T20:33:25.143Z',
            updatedAt: '2024-03-04T20:33:25.143Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'In which time zone is the shipment time recorded for direct orders?\u202f - US',
            question: 'In which time zone is the shipment time recorded for direct orders?\u202f ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Departing shipments are recorded in Eastern Time (ET). Delivery times are provided in the destination\'s local time zone. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '2epqyFMAI9YaLl4BWqLha5',
            type: 'Entry',
            createdAt: '2024-03-04T20:33:49.603Z',
            updatedAt: '2024-03-04T20:33:49.603Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Who do I contact for inquiries about shipments that are in transit or just delivered?\u202f\u202f - US',
            question: 'Who do I contact for inquiries about shipments that are in transit or just delivered?\u202f\u202f ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'If you ordered through an ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'Authorized Distributor',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ', please reach out to them directly for details on shipping, delivery, and the condition of the product.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'If you ordered directly from Moderna, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\u202f\u202f\u202f\u202f\u202f\u202f',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1v6uDUCfEco3z4A8EoO5A3',
            type: 'Entry',
            createdAt: '2024-03-04T20:34:09.981Z',
            updatedAt: '2024-03-04T20:34:09.981Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'I have questions about my ship date and transit time. Who should I talk to?\u202f - US',
            question: 'I have questions about my ship date and transit time. Who should I talk to?\u202f ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you placed your order directly with Moderna, contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and speak with the Shipping Department for details about ship dates and transit times.  ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'WX8ugSSXn5kLcEDpwDa69',
            type: 'Entry',
            createdAt: '2024-03-04T20:34:39.124Z',
            updatedAt: '2024-03-04T20:34:39.124Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What are the packaging dimensions and weight? - US',
            question: 'What are the packaging dimensions and weight? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Packaging dimensions and weight specifics for 2023-2024 products are: ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Prefilled Syringe Blister Pack: Weight (0.24lbs); Depth (2.25in) Width (5.25in) Height (3.43in) Volume (in3) (38.84in) ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Single-Dose Vial: Weight (0.21lbs); Depth (3.68in) Width (1.54in) Height (2.20in) Volume (in3) (11.76in) ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Information on 2024-2025 products in forthcoming. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '5HQpjj7VcXSfotDHD1Mhdf',
            type: 'Asset',
            createdAt: '2024-03-04T20:31:18.285Z',
            updatedAt: '2024-03-04T20:31:18.285Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Shipping Icon',
            description: 'Shipping Icon',
            file: {
            url: shipping,
            details: {
                size: 882,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '4.Shipping.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7iOWBmppZrkK5s40UUIzOV',
            type: 'Entry',
            createdAt: '2023-09-28T22:24:03.948Z',
            updatedAt: '2023-09-28T22:24:03.948Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '3V2Uucd9KUo2INmsnQwwWZ',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Delivery - US',
        name: 'Delivery ',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1N4NM4ESqmEvLLMhX1dERe',
            type: 'Entry',
            createdAt: '2024-03-04T20:36:05.059Z',
            updatedAt: '2024-03-04T20:36:05.059Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'When can I expect my order delivered? - US',
            question: 'When can I expect my order delivered? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Shipping timelines and dates will be provided once the product is available. If you previously reserved your supply, we will notify you when shipping dates are available so you can confirm your order, shipping address, and desired delivery date. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Following product availability, most products will ship the next day. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'qSh6h1BKvIUOEptpMq55m',
            type: 'Entry',
            createdAt: '2024-03-04T20:36:21.539Z',
            updatedAt: '2024-03-04T20:36:21.539Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why am I not able to select a preferred delivery date? - US',
            question: 'Why am I not able to select a preferred delivery date? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'If an order is placed before 1pm EST, the earliest date for requested delivery would be +1 business day from date of order. If an order is placed after 1pm EST, the earliest date for requested delivery would be +2 business days from date of order. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3vB3PJDiVaMgKs2X1JDOk',
            type: 'Entry',
            createdAt: '2024-03-04T20:36:39.222Z',
            updatedAt: '2024-03-04T20:36:39.222Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What should I verify on the packing list? - US',
            question: 'What should I verify on the packing list? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Please verify the shipping quantity and the MFR Lot# on the ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/packing-slip'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'packing slip',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: '.  ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1qlSGiLFHbxcbHVFErls0G',
            type: 'Entry',
            createdAt: '2024-03-04T20:36:54.530Z',
            updatedAt: '2024-03-04T20:36:54.530Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What counts as a small parcel order? - US',
            question: 'What counts as a small parcel order? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Small parcel orders refer to orders that don\'t have enough volume for a truck shipment. They are dispatched in containers suitable for the order size, ranging from S to XL. A small parcel refers to an order of less than ~ 130 cartons (1,330 doses). ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4KZzufXdAwVz6abmwXJLff',
            type: 'Entry',
            createdAt: '2024-03-04T20:37:14.644Z',
            updatedAt: '2024-03-04T20:37:14.644Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'When are small parcel orders (< ~130 cartons) shipped out, and when are they expected to be delivered?\u202f - US',
            question: 'When are small parcel orders (< ~130 cartons) shipped out, and when are they expected to be delivered?\u202f ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Small parcel orders that are shipped out from Monday to Thursday are expected to be delivered by 10:30am the next day. Orders that are shipped out on Friday are intended for Saturday deliveries and are expected to be delivered between the hours of 9am-5pm. There are no outbound shipments on Saturday or Sunday. ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If a package is at risk of not being delivered on its scheduled day, UPS will make a second attempt before the day ends. If both delivery attempts are unsuccessful, UPS will initiate the "Return to Sender" process automatically. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '1Vu7rBb9snk16lKt5bFsbx',
            type: 'Asset',
            createdAt: '2024-03-04T20:35:29.143Z',
            updatedAt: '2024-03-04T20:35:29.143Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Delivery Icon',
            description: 'Delivery Icon',
            file: {
            url: delivery,
            details: {
                size: 948,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '5.Delivery.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7iOWBmppZrkK5s40UUIzOV',
            type: 'Entry',
            createdAt: '2023-09-28T22:24:03.948Z',
            updatedAt: '2023-09-28T22:24:03.948Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '7adD7IA5cqQ31Lf1iIAxRD',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Temperature Monitoring - US',
        name: 'Temperature Monitoring ',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6kPVb3yGEeyARLiSE0luei',
            type: 'Entry',
            createdAt: '2024-03-04T20:39:33.459Z',
            updatedAt: '2024-03-04T20:39:33.459Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Is there a temperature monitoring device included in truck shipments?\u202f - US',
            question: 'Is there a temperature monitoring device included in truck shipments?\u202f ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'A Sensitech Temperature Monitoring Device (TMD) is included with truck shipments but not with parcel shipments. Small parcel orders use insulated containers with gel packs to maintain the proper temperature during shipment.\u202f ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'For truck orders, there are two TMDs per pallet, and they are located in an upper and a lower area of each pallet. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7H1zNMBkVex5aNM3zMJGXL',
            type: 'Entry',
            createdAt: '2024-03-04T20:41:38.154Z',
            updatedAt: '2024-03-04T20:41:38.154Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What should I do when I receive my parcel shipment?   - US',
            question: 'What should I do when I receive my parcel shipment?   ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'ordered-list',
                    data: {},
                    content: [
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Immediately open the package. ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Verify the contents by confirming they match the packing list. ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Inspect the quality of the contents, i.e., look for signs of tampering, broken seals, etc. ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Place the vaccine in the appropriate storage. ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Repack and return the cooler (using the instructions below). ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: '',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '2yO1RpjTgemPaO1WdoF5Cq',
            type: 'Entry',
            createdAt: '2024-03-04T20:41:57.518Z',
            updatedAt: '2024-03-04T20:41:57.518Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I discard the cooler that came with my parcel shipment?   - US',
            question: 'Can I discard the cooler that came with my parcel shipment?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'No. Please repack and return the cooler components to your regular pick-up person or schedule a pickup via 1-800-PICK-UPS. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '13HKfv8o3hyRgF8SbMG5D2',
            type: 'Entry',
            createdAt: '2024-03-04T20:43:56.814Z',
            updatedAt: '2024-03-04T20:43:56.814Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Is there a return label to send back the cooler?   - US',
            question: 'Is there a return label to send back the cooler?   ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'The return shipping label can be found on the inside flap of your EcoFlex box. For more information, contact ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'mailto:info@coldchaintech.com'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'info@coldchaintech.com',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: '.  ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5oNkPrHFzeGWcQwdx6LaRu',
            type: 'Entry',
            createdAt: '2024-03-04T20:44:26.986Z',
            updatedAt: '2024-03-04T20:44:26.986Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I prepare the cooler to send back?  - US',
            question: 'How do I prepare the cooler to send back?  ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'ordered-list',
                    data: {},
                    content: [
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Open the shipper and remove the top Koolit PCM gel pack(s).  ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Remove the vaccine from the inner corrugated box.  ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Ensure the inner corrugated box is back in the EcoFlex shipping system. (IMPORTANT: this will help prevent damage during return.) ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Place the top Koolit PCM gel pack(s) back on top. (IMPORTANT: This will help prevent damage during return.) ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Fold in the original outer flaps. Fold in the remaining flaps and ensure the return shipping label is visible. Tape the seam.  ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    },
                    {
                        nodeType: 'list-item',
                        data: {},
                        content: [
                        {
                            nodeType: 'paragraph',
                            data: {},
                            content: [
                            {
                                nodeType: 'text',
                                value: 'Give the cooler to your regular delivery person for return. If you do not have a regular service, call 1-800-PICK-UPS to schedule a pickup from your location. ',
                                marks: [],
                                data: {}
                            }
                            ]
                        }
                        ]
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: '',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'hlL9y3uo1uxCUgyw0qyqo',
            type: 'Entry',
            createdAt: '2024-03-04T20:44:46.663Z',
            updatedAt: '2024-03-04T20:44:46.663Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the purpose of the gel packs included in the parcel package?\u202f - US',
            question: 'What is the purpose of the gel packs included in the parcel package?\u202f ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'The gel packs help maintain the required temperature range during shipment.\u202f ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '68eDcEAPfYA5T8LZR7sFR5',
            type: 'Entry',
            createdAt: '2024-03-04T20:45:05.099Z',
            updatedAt: '2024-03-04T20:45:05.099Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Where can I find the Sensitech Temperature Monitoring Device (TMD) in my parcel order?\u202f - US',
            question: 'Where can I find the Sensitech Temperature Monitoring Device (TMD) in my parcel order?\u202f ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Temperature monitoring devices are only included in truck shipments, not in small parcel orders shipped by UPS.\u202f Small parcel orders contain Koolit freeze packs. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'wEnvoQjpDHHNE30gqN2hX',
            type: 'Entry',
            createdAt: '2024-03-04T20:45:27.379Z',
            updatedAt: '2024-03-04T20:45:27.379Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How can I check if the product experienced temperature fluctuations during delivery?\u202f - US',
            question: 'How can I check if the product experienced temperature fluctuations during delivery?\u202f ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Small Parcel Orders are shipped in insulated containers (with gel packs) that have been validated to maintain the proper temperature between -50°C and -15°C (-58°F and 5°F) for the duration of the shipment.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Truck Deliveries contain Sensitech Temperature Monitoring Devices. Refer to the attached description from Supply Chain for details on the Temperature Monitoring Device. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '54ISKmlzSuTcjE5zPXnyKt',
            type: 'Asset',
            createdAt: '2024-03-04T20:38:25.378Z',
            updatedAt: '2024-03-04T20:38:25.378Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Temperature Monitoring Icon',
            description: 'Temperature Monitoring Icon',
            file: {
            url: temperatureMonitoring,
            details: {
                size: 1444,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '6.RecievingYourOrder.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7iOWBmppZrkK5s40UUIzOV',
            type: 'Entry',
            createdAt: '2023-09-28T22:24:03.948Z',
            updatedAt: '2023-09-28T22:24:03.948Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '2cDVmsEPE8x2wL7j04C8QK',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Delivery Issues - US',
        name: 'Delivery Issues',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3yvWyd3mt9v4BXc6IxO2HK',
            type: 'Entry',
            createdAt: '2024-03-04T20:49:04.742Z',
            updatedAt: '2024-03-04T20:49:04.742Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What should I do about a late delivery? - US',
            question: 'What should I do about a late delivery? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If your delivery is late, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option “If you are calling about an order including a delivery.”  ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Questions associated with product viability will be addressed by Moderna’s Medical Information Contact Center Team. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4jQ3u7ItvOBPgpZB2iT4Bz',
            type: 'Entry',
            createdAt: '2024-03-04T20:49:25.814Z',
            updatedAt: '2024-03-04T20:49:25.814Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I report an incorrect order that I received? - US',
            question: 'How do I report an incorrect order that I received? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'If you received an incorrect order, check your packing slip to determine if you are a direct or indirect customer. If you are a direct customer, your slip will list “Moderna US” as the “Seller.” In that case, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option “If you are calling about an order including a delivery.”   ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'For Indirect orders, the packing list/invoice will have your ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'Authorized Distributor',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ' listed as the “Seller.” Indirect customers should contact their ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'Authorized Distributor',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ' directly for assistance. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1uNAjiCEaJyXrPBNmmlPFU',
            type: 'Entry',
            createdAt: '2024-03-04T20:49:46.354Z',
            updatedAt: '2024-03-04T20:49:46.354Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I report a damaged order?  - US',
            question: 'How do I report a damaged order?  ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you placed your order directly with Moderna please contact the Moderna customer care team at 1-866-MODERNA (1-866-663-3762). If you placed your order via an ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'Authorized Distributor',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ' please contact them for assistance. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '56WcPXSXiTc44PrdoKb6i',
            type: 'Entry',
            createdAt: '2024-03-04T20:50:06.988Z',
            updatedAt: '2024-03-04T20:50:06.988Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the process for orders delivered to the wrong address or department?\u202f - US',
            question: 'What is the process for orders delivered to the wrong address or department?\u202f ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option “If you are calling about an order including a delivery.”  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Questions associated with product viability will be addressed by Moderna’s Medical Information Contact Center Team. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1CLhH904ZTt20ZDJPpFRZA',
            type: 'Entry',
            createdAt: '2024-03-04T20:50:34.633Z',
            updatedAt: '2024-03-04T20:50:34.633Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What should I do if my shipment was left out for an extended period after delivery?\u202f\u202f - US',
            question: 'What should I do if my shipment was left out for an extended period after delivery?\u202f\u202f ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'For post-delivery inquiries, such as products left out overnight or for several hours after delivery, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option to report an excursion or product quality concern. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4nfjX4c6XlxmQe0r4b28MT',
            type: 'Entry',
            createdAt: '2024-03-04T20:50:51.784Z',
            updatedAt: '2024-03-04T20:50:51.784Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How can I assess the stability of the product when the gel packs in my parcel order are partially or completely thawed?\u202f - US',
            question: 'How can I assess the stability of the product when the gel packs in my parcel order are partially or completely thawed?\u202f ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you are concerned with temperature monitoring during shipment and/or if the Koolit freeze pack appears melted or “slushy,” please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).\u202f ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3N2G99J0SYuFt2tAPm0cui',
            type: 'Entry',
            createdAt: '2024-03-04T20:51:16.492Z',
            updatedAt: '2024-03-04T20:51:16.492Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What should I do if the Sensitech Temperature Monitoring Device in my truck shipment expired or if there are issues during delivery?\u202f - US',
            question: 'What should I do if the Sensitech Temperature Monitoring Device in my truck shipment expired or if there are issues during delivery?\u202f ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option “For medical questions or temperature excursions.”  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Moderna’s Shipping Team will handle the inquiry and advise on the viability of the product based on the ship date.\u202f ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '56GhNyvmcVonaDMuswoi5y',
            type: 'Entry',
            createdAt: '2024-03-04T20:51:47.076Z',
            updatedAt: '2024-03-04T20:51:47.076Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 4,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How can I assess the stability of the product when the product is partially or completely thawed?\u202f - US',
            question: 'How can I assess the stability of the product when the product is partially or completely thawed?\u202f ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Upon receiving your delivery, immediately follow these steps:\u202f ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Packaging Inspection: Upon receipt, inspect the packaging for any signs of damage or compromise to the Koolit freeze pack, Temperature Monitoring Device, or the vaccine vials. Physical damage could potentially affect the temperature control and, thereby, the stability of the vaccine.\u202f ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Vaccine Condition: Check the condition of the vials upon receipt. Any changes in color or the presence of particles could indicate a stability issue. If you suspect this is the case, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Storage Conditions Post-Delivery: Ensure that vaccines are stored under recommended conditions immediately after the package is opened.\u202f \n \nRemember to follow the ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://assets.modernatx.com/m/7ce607d0bf1f0e20/original/FPI-0717_Spikevax-2023-2024-Formula-Prescribing-Information-PI-12y-US-English.pdf'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'specific guidelines',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ' provided for the storage and handling of Moderna vaccines to ensure their efficacy. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5XYn2ami8fpDNGyzysKnq5',
            type: 'Entry',
            createdAt: '2024-03-04T20:53:29.706Z',
            updatedAt: '2024-03-04T20:53:29.706Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 7,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'To whom do I direct questions about temperature excursion and/or vaccine viability? - US',
            question: 'To whom do I direct questions about temperature excursion and/or vaccine viability? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If the order was placed via 1-866-MODERNA, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you’re an indirect customer with questions regarding temperature excursions or vaccine viability, contact your ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://modernadirect.com/authorized-distributor'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'Authorized Distributor',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: '.',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '6vH5MC5BRbIWXUcbhiQtEi',
            type: 'Asset',
            createdAt: '2024-03-04T20:48:15.899Z',
            updatedAt: '2024-03-04T20:48:15.899Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Delivery Issues/troubleshooting Icon',
            description: 'Delivery Issues/troubleshooting Icon',
            file: {
            url: troubleshooting,
            details: {
                size: 2025,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '8.deliveryissues.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7iOWBmppZrkK5s40UUIzOV',
            type: 'Entry',
            createdAt: '2023-09-28T22:24:03.948Z',
            updatedAt: '2023-09-28T22:24:03.948Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '1e1pyDFGGOUcA9FSd2Ig1G',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Storage & Usage - US',
        name: 'Storage & Usage',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '7h37T6ygJwNhh73fpzs3ht',
            type: 'Entry',
            createdAt: '2023-01-09T20:51:35.401Z',
            updatedAt: '2024-03-04T20:55:26.879Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 43,
            revision: 9,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How do I store and handle the product? - US',
            question: 'How do I store and handle the product?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Please follow the ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://assets.modernatx.com/m/7ce607d0bf1f0e20/original/FPI-0717_Spikevax-2023-2024-Formula-Prescribing-Information-PI-12y-US-English.pdf'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'specific guidelines',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ' for the storage and handling of the vaccines to ensure their efficacy. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'l8B7JSAhSJEXj1hHljbdj',
            type: 'Entry',
            createdAt: '2024-03-04T20:55:50.783Z',
            updatedAt: '2024-03-04T20:55:50.783Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I re-freeze a vaccine once it has been thawed?  - US',
            question: 'Can I re-freeze a vaccine once it has been thawed?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'No, vaccines cannot be refrozen. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6dudVXkJ2xRosztvZl5TLi',
            type: 'Entry',
            createdAt: '2023-08-14T17:57:30.330Z',
            updatedAt: '2024-03-04T20:56:44.673Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 16,
            revision: 4,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is the recommended needle length and gauge needed for administering the vaccine?  -US',
            question: 'What is the recommended needle length and gauge needed for administering the vaccine? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'Clinical judgment should be used when administering the vaccine. Please visit the ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'https://www.cdc.gov/vaccines/hcp/admin/downloads/vaccine-administration-needle-length.pdf'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'CDC’s guidelines',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ' or call our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '51MiVX0gATHqRpMDE6YKQc',
            type: 'Entry',
            createdAt: '2023-09-11T20:26:45.590Z',
            updatedAt: '2024-03-04T20:56:59.226Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Will needles be supplied for vaccine vials? - US',
            question: 'Will needles be supplied for vaccine vials? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'No, we do not supply needles with orders. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '3oNZtV07gpXTsnf7wMSPTX',
            type: 'Asset',
            createdAt: '2023-05-08T16:52:21.575Z',
            updatedAt: '2023-05-08T16:52:21.575Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 6,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Moderna_Icon_accessMedicine',
            description: 'Access Medicine Icon',
            file: {
            url: accessMedicine,
            details: {
                size: 39343,
                image: {
                width: 600,
                height: 600
                }
            },
            fileName: 'accessMedicine.png',
            contentType: 'image/png'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7sht7920U6vs3CLH2CUyaa',
            type: 'Entry',
            createdAt: '2023-05-18T03:23:50.744Z',
            updatedAt: '2023-05-24T22:55:23.250Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: 'ibxOxjjfx6Zd11ku1Rx6b',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Returns - US',
        name: 'Returns ',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '2zBG4m5kqr43gbHKiBTXfy',
            type: 'Entry',
            createdAt: '2024-03-04T20:59:12.158Z',
            updatedAt: '2024-03-04T20:59:12.158Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'What is your return policy?  - US',
            question: 'What is your return policy?  ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you need to return vaccines because there was a problem with your shipment (such as a temperature excursion), please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).   ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'The policy for end-of-season returns of unused products will vary by contract. Please consult your contract for more information about return eligibility and guidelines or contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) if you still have questions. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'RZLgzJ0kQVm711RS37YZy',
            type: 'Entry',
            createdAt: '2024-03-04T20:59:40.951Z',
            updatedAt: '2024-03-04T20:59:40.951Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I return unused Spikevax vaccines?  - US',
            question: 'Can I return unused Spikevax vaccines?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'If you need to return your Spikevax products due to a shipping error, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). For end-of-season returns, see our ',
                        nodeType: 'text'
                    },
                    {
                        data: {
                        uri: 'https://modernadirect.com/return-goods-policy'
                        },
                        content: [
                        {
                            data: {},
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            value: 'Vaccine Product Return Policy',
                            nodeType: 'text'
                        }
                        ],
                        nodeType: 'hyperlink'
                    },
                    {
                        data: {},
                        marks: [],
                        value: ' or your contract for specific details.  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '24J8yiYWPw56NYDLge8wHD',
            type: 'Entry',
            createdAt: '2024-03-04T21:00:01.057Z',
            updatedAt: '2024-03-04T21:00:01.057Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Can I return unused pediatric COVID-19 vaccines? - US',
            question: 'Can I return unused pediatric COVID-19 vaccines? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'All privately purchased pediatric COVID-19 vaccine doses (NDC No. 80777-0287-92) purchased on or after January 9, 2024 will be 100% returnable for the entire season, pursuant to the return policies and procedures provided in your contract with Moderna.   ',
                        marks: [],
                        data: {}
                    }
                    ]
                },
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'If you placed an order with us through ',
                        marks: [],
                        data: {}
                    },
                    {
                        nodeType: 'hyperlink',
                        data: {
                        uri: 'http://www.modernadirect.com/'
                        },
                        content: [
                        {
                            nodeType: 'text',
                            value: 'ModernaDirect.com',
                            marks: [
                            {
                                type: 'underline'
                            }
                            ],
                            data: {}
                        }
                        ]
                    },
                    {
                        nodeType: 'text',
                        value: ', please call our Customer Care Team at 1-866-MODERNA (1-866-663-3762) between 8:00AM - 8:00PM EST, Monday - Friday (excluding holidays).  ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5RbYS911KrhmNHoGey0quP',
            type: 'Entry',
            createdAt: '2024-03-04T21:00:16.978Z',
            updatedAt: '2024-03-04T21:00:16.978Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Will I be entitled to a full refund if I return part of an order?  - US',
            question: 'Will I be entitled to a full refund if I return part of an order?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Your refund terms depend on your specific contract. If you still have questions about what you can return and the type of refund or credit you will receive, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5iOpOR6CDL0vy78xiFJgt3',
            type: 'Entry',
            createdAt: '2024-03-04T21:00:34.396Z',
            updatedAt: '2024-03-04T21:00:34.396Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'How much of my order is eligible for return?  - US',
            question: 'How much of my order is eligible for return?  ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Return policies vary by contract. Please consult your contract for more information about return eligibility and guidelines. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '3wlhlOCUTWTWdZMlroWQmB',
            type: 'Entry',
            createdAt: '2024-03-04T21:01:14.944Z',
            updatedAt: '2024-03-04T21:01:14.944Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 5,
            revision: 1,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'I received an incorrect order, or my products were damaged during shipping. How do I return these products? - US',
            question: 'I received an incorrect order, or my products were damaged during shipping. How do I return these products? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762) and select the option “If you are calling about an order including a delivery.”  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'Your call will be routed to our Shipping Team, and they will validate the return request & issue a Return Materials Authorization (RMA).  ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'If the excursion happened during the shipping process or upon delivery, our Shipping Team will validate the information. If there was a post-delivery excursion Moderna’s Medical Information Contact Center Team will validate the information.   ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                },
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'If there was an order entry error (either by Moderna, or the Customer), the Moderna Commercial Operations Team will validate the return request and ask the Shipping Team to issue an RMA and process credit upon receipt of the product. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7iOWBmppZrkK5s40UUIzOV',
                type: 'Entry',
                createdAt: '2023-09-28T22:24:03.948Z',
                updatedAt: '2023-09-28T22:24:03.948Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 3,
                revision: 1,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '634MGB1iRc2Bb1zuqBFPEn',
            type: 'Asset',
            createdAt: '2024-03-04T20:58:30.633Z',
            updatedAt: '2024-03-04T20:58:30.633Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Returns Icon',
            description: 'Returns Icon',
            file: {
            url: accessMedicine,
            details: {
                size: 1386,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '9.returns.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7iOWBmppZrkK5s40UUIzOV',
            type: 'Entry',
            createdAt: '2023-09-28T22:24:03.948Z',
            updatedAt: '2023-09-28T22:24:03.948Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 3,
            revision: 1,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '577KhhCkIQaRgR4CtIQ5ou',
        type: 'Entry'
    }
    },
    {
    fields: {
        title: 'Website Troubleshooting  - US ',
        name: 'Website Troubleshooting ',
        faqEntries: [
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '14dr2GVLfS4UDwV7ORa79k',
            type: 'Entry',
            createdAt: '2023-01-09T22:07:06.329Z',
            updatedAt: '2024-03-04T21:02:37.527Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 20,
            revision: 8,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why don’t I see my orders when I click on “View my orders” CTA in order acknowledgement page? - US',
            question: 'Why don’t I see my orders when I click on “View my orders” CTA in order acknowledgement page? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'There could be a minute lag to see your cart is submitted with multiple delivery addresses; please refresh your page after a minute to see your order history. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5fS7J4YawI4BByEeq5YegN',
            type: 'Entry',
            createdAt: '2023-08-14T17:50:24.479Z',
            updatedAt: '2024-03-04T21:02:53.564Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 8,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see "Your cart has been updated as product(s) in your cart are no longer available" pop up? - US',
            question: 'Why do I see "Your cart has been updated as product(s) in your cart are no longer available" pop up? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'This pop up occurs when selected products are no longer available in the inventory to be ordered and hence your cart has been updated to not show that product(s). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '5Bsa9YR3Vhy1T7OetEUNLk',
            type: 'Entry',
            createdAt: '2023-08-14T17:52:07.180Z',
            updatedAt: '2024-03-04T21:03:09.662Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see "Your cart has been updated as quantities selected in your cart are no longer available" pop up? -US',
            question: 'Why do I see "Your cart has been updated as quantities selected in your cart are no longer available" pop up? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'This pop up occurs when selected doses are no longer available in the open / global inventory and hence your cart has been updated to reflect the maximum doses available to order. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: 'FTKVTdZ0iXJeAN247sFeY',
            type: 'Entry',
            createdAt: '2023-07-26T13:20:18.702Z',
            updatedAt: '2024-03-04T21:03:42.022Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 12,
            revision: 3,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see “Quantity exceeds available inventory” pop up? - US',
            question: 'Why do I see “Quantity exceeds available inventory” pop up?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'This pop up occurs when quantity that you selected exceeds the open / global inventory level maintained for the selected product(s) ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '656ghvJjS2YUn2twwa521n',
            type: 'Entry',
            createdAt: '2023-07-26T13:23:10.875Z',
            updatedAt: '2024-03-04T21:04:03.767Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 9,
            revision: 3,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see “Quantity selected at delivery level for the product do not add up to total quantity for the product” pop up? - US',
            question: 'Why do I see “Quantity selected at delivery level for the product do not add up to total quantity for the product” pop up? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'This pop up occurs when quantities requested for each delivery location do not add up to the total quantity of the SKU/Product. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '4Rx7cRTb0RBB7aM39gvzU4',
            type: 'Entry',
            createdAt: '2023-07-26T13:26:19.231Z',
            updatedAt: '2024-03-04T21:04:26.306Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 7,
            revision: 2,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see “Maximum line items have been reached in the cart” pop up? - US',
            question: 'Why do I see “Maximum line items have been reached in the cart” pop up?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'This pop up occurs when the total line items in the cart exceeds 99. A separate sales order would be required to accommodate any additional line item. ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '494slywfpUOcV7BJXvfpa8',
            type: 'Entry',
            createdAt: '2023-07-26T13:26:52.243Z',
            updatedAt: '2024-03-04T21:04:51.696Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 9,
            revision: 3,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see “product is now out of stock” pop up?  - US',
            question: 'Why do I see “product is now out of stock” pop up? ',
            answer: {
                data: {},
                content: [
                {
                    data: {},
                    content: [
                    {
                        data: {},
                        marks: [],
                        value: 'This pop up occurs when the product is no longer available to be ordered. ',
                        nodeType: 'text'
                    }
                    ],
                    nodeType: 'paragraph'
                }
                ],
                nodeType: 'document'
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '1prfBEzA5B8cw9iIRBEFTI',
            type: 'Entry',
            createdAt: '2023-07-26T13:27:18.338Z',
            updatedAt: '2024-03-04T21:05:18.551Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 9,
            revision: 3,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see “An error occurred, the issue may be temporary. Please try again” pop up? - US',
            question: 'Why do I see “An error occurred, the issue may be temporary. Please try again” pop up? ',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'This pop-up occurs when there’s an unexpected issue. To troubleshoot, please refer to your browser instructions to clear the cache or try reloading the page again at a later time. If the issue still persists, and you continue to see an “Error 500” pop-up, please contact contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6Z2SPc2JrfNjdWCGlZHUX9',
            type: 'Entry',
            createdAt: '2023-07-26T13:31:14.129Z',
            updatedAt: '2024-03-04T21:05:52.235Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 12,
            revision: 3,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see “Error 404” pop up? - US',
            question: 'Why do I see “Error 404” pop up?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'You’ll see an “Error 404” message if there’s an issue with the page you’re trying to access, or if the page does not exist. To troubleshoot, please refer to your browser instructions to clear the cache or try reloading the page again at a later time. If the issue still persists, and you continue to see an “Error 404” message, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762).',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        },
        {
            metadata: {
            tags: [],
            concepts: []
            },
            sys: {
            space: {
                sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
                }
            },
            id: '6G8qosB3C8RjALpLzKqQ5x',
            type: 'Entry',
            createdAt: '2023-07-26T13:31:43.146Z',
            updatedAt: '2024-03-04T21:06:00.499Z',
            environment: {
                sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
                }
            },
            publishedVersion: 9,
            revision: 3,
            contentType: {
                sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'faqEntries'
                }
            },
            locale: 'en-US'
            },
            fields: {
            title: 'Why do I see “Error 500” pop up? - US',
            question: 'Why do I see “Error 500” pop up?',
            answer: {
                nodeType: 'document',
                data: {},
                content: [
                {
                    nodeType: 'paragraph',
                    data: {},
                    content: [
                    {
                        nodeType: 'text',
                        value: 'This pop-up occurs when there’s an unexpected issue. To troubleshoot, please refer to your browser instructions to clear the cache or try reloading the page again at a later time. If the issue still persists, and you continue to see an “Error 500” pop-up, please contact our Customer Care Team at 1-866-MODERNA (1-866-663-3762). ',
                        marks: [],
                        data: {}
                    }
                    ]
                }
                ]
            },
            country: {
                metadata: {
                tags: [],
                concepts: []
                },
                sys: {
                space: {
                    sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                    }
                },
                id: '7sht7920U6vs3CLH2CUyaa',
                type: 'Entry',
                createdAt: '2023-05-18T03:23:50.744Z',
                updatedAt: '2023-05-24T22:55:23.250Z',
                environment: {
                    sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                    }
                },
                publishedVersion: 6,
                revision: 2,
                contentType: {
                    sys: {
                    type: 'Link',
                    linkType: 'ContentType',
                    id: 'country'
                    }
                },
                locale: 'en-US'
                },
                fields: {
                name: 'United States',
                isocode: 'US',
                flag: {
                    metadata: {
                    tags: [],
                    concepts: []
                    },
                    sys: {
                    space: {
                        sys: {
                        type: 'Link',
                        linkType: 'Space',
                        id: 'n9bebhw263o0'
                        }
                    },
                    id: '3aYCbZJiL8aoEKRdhjOXyy',
                    type: 'Asset',
                    createdAt: '2023-05-24T22:54:50.939Z',
                    updatedAt: '2023-05-24T22:54:50.939Z',
                    environment: {
                        sys: {
                        id: 'sandbox',
                        type: 'Link',
                        linkType: 'Environment'
                        }
                    },
                    publishedVersion: 5,
                    revision: 1,
                    locale: 'en-US'
                    },
                    fields: {
                    title: 'usa flag',
                    description: 'USA Flag',
                    file: {
                        url: usaFlag,
                        details: {
                        size: 2487,
                        image: {
                            width: 36,
                            height: 26
                        }
                        },
                        fileName: 'usa_flag.svg',
                        contentType: 'image/svg+xml'
                    }
                    }
                },
                locales: [
                    'en-US'
                ]
                }
            }
            }
        }
        ],
        icon: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '2nXlMtFKQzomSx5q8uMwAY',
            type: 'Asset',
            createdAt: '2024-03-04T21:06:48.634Z',
            updatedAt: '2024-03-04T21:06:48.634Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 4,
            revision: 1,
            locale: 'en-US'
        },
        fields: {
            title: 'Website Troubleshooting Icon',
            description: 'Website Troubleshooting Icon',
            file: {
            url: websiteTroubleshooting,
            details: {
                size: 1860,
                image: {
                width: 120,
                height: 120
                }
            },
            fileName: '10.troubleshooting.svg',
            contentType: 'image/svg+xml'
            }
        }
        },
        country: {
        metadata: {
            tags: [],
            concepts: []
        },
        sys: {
            space: {
            sys: {
                type: 'Link',
                linkType: 'Space',
                id: 'n9bebhw263o0'
            }
            },
            id: '7sht7920U6vs3CLH2CUyaa',
            type: 'Entry',
            createdAt: '2023-05-18T03:23:50.744Z',
            updatedAt: '2023-05-24T22:55:23.250Z',
            environment: {
            sys: {
                id: 'sandbox',
                type: 'Link',
                linkType: 'Environment'
            }
            },
            publishedVersion: 6,
            revision: 2,
            contentType: {
            sys: {
                type: 'Link',
                linkType: 'ContentType',
                id: 'country'
            }
            },
            locale: 'en-US'
        },
        fields: {
            name: 'United States',
            isocode: 'US',
            flag: {
            metadata: {
                tags: [],
                concepts: []
            },
            sys: {
                space: {
                sys: {
                    type: 'Link',
                    linkType: 'Space',
                    id: 'n9bebhw263o0'
                }
                },
                id: '3aYCbZJiL8aoEKRdhjOXyy',
                type: 'Asset',
                createdAt: '2023-05-24T22:54:50.939Z',
                updatedAt: '2023-05-24T22:54:50.939Z',
                environment: {
                sys: {
                    id: 'sandbox',
                    type: 'Link',
                    linkType: 'Environment'
                }
                },
                publishedVersion: 5,
                revision: 1,
                locale: 'en-US'
            },
            fields: {
                title: 'usa flag',
                description: 'USA Flag',
                file: {
                url: usaFlag,
                details: {
                    size: 2487,
                    image: {
                    width: 36,
                    height: 26
                    }
                },
                fileName: 'usa_flag.svg',
                contentType: 'image/svg+xml'
                }
            }
            },
            locales: [
            'en-US'
            ]
        }
        }
    },
    sys: {
        id: '01HSzJ8lmenE635sqrJjFn',
        type: 'Entry'
    }
    }
]
